<!-- Admin Pages Container -->
<div class="admin-pages-container">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>